import React from "react";
import { Row, Col } from "react-bootstrap";
import { RBSModal } from "../../base/rbs_components/RBSModal.tsx";
import { RBSTextField } from "../../base/rbs_components/RBSTextField.tsx";
import { RBSDropdown } from "../../base/rbs_components/RBSDropdown.tsx";
import type { TimeSeriesInput } from "../../base/ui_general/GeneralInterfaces.tsx";
import type { InputStateControl } from "../../base/utils/InputStateControl.tsx";
import type { UserLanguages } from "../../base/Settings.tsx";
import { ValidationSchemes, LabelTextMessageTypes, TimeSeriesTypeEnum } from "../../base/Settings.tsx";
import { getLabelTextMessage } from "../../base/utils/GeneralUtilities.tsx";

//TODO: There are places where the multi-language support is missing


interface TimeSeriesDetailModalProps {
    /** Whether the modal is visible */
    show: boolean;
    /** The time series object to edit (if any) */
    timeSeries?: TimeSeriesInput;
    /** Callback for submitting the form, receives a partial input object */
    onSubmit: (input: Partial<TimeSeriesInput>) => void;
    /** Callback for closing the modal */
    onClose: () => void;
    /** Indicates if the form is valid */
    isValid: boolean;
    /** Manages input state and validation */
    inputStateControl: InputStateControl;
    /** The current user language for multi-language support */
    user_language: UserLanguages;
}


export const TimeSeriesDetailModal: React.FC<TimeSeriesDetailModalProps> = (props) => {
    const { timeSeries, inputStateControl, user_language } = props;

    const prefill = (key: keyof TimeSeriesInput): string => {
        if (timeSeries && timeSeries[key] !== undefined && timeSeries[key] !== null) {
            return String(timeSeries[key]);
        }
        return "";
    };

    const headerTitle = timeSeries ? "Update Time Series" : "Create New Time Series";

    return (
        <RBSModal
            show={props.show}
            header_title={headerTitle}
            show_close_button
            onClose={props.onClose}
            primary_button_label={getLabelTextMessage(LabelTextMessageTypes.SUBMIT, user_language)}
            secondary_button_label={getLabelTextMessage(LabelTextMessageTypes.CANCEL, user_language)}
            onClickSecondary={props.onClose}
            primary_button_disabled={!props.isValid}
            size="sm"
            onClickPrimary={() => {
                const input: Partial<TimeSeriesInput> = {
                    name: inputStateControl.getStringValueForKey("name"),
                    description: inputStateControl.getStringValueForKey("description"),
                    type: inputStateControl.getStringValueForKey("type") as TimeSeriesTypeEnum | undefined,
                };
                props.onSubmit(input);
                //props.onClose();
            }}
        >
            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Name"
                        input_key="name"
                        prefill={prefill("name")}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <RBSTextField
                        label="Description"
                        input_key="description"
                        prefill={prefill("description")}
                        validation_schemes={[]}
                        input_state_control={inputStateControl}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <RBSDropdown
                        label="Time Series Type"
                        input_key="type"
                        prefill={prefill("type") || TimeSeriesTypeEnum.OTHER}
                        items={[
                            { label: "Interest Rate", value: TimeSeriesTypeEnum.INTEREST_RATE },
                            { label: "FX Rate", value: TimeSeriesTypeEnum.FX_RATE },
                            { label: "Amortization Rate", value: TimeSeriesTypeEnum.AMORTIZATION_RATE },
                            { label: "Other", value: TimeSeriesTypeEnum.OTHER },
                        ]}
                        input_state_control={inputStateControl}
                        validation_schemes={[ValidationSchemes.REQUIRED]}
                    />
                </Col>
            </Row>
        </RBSModal>
    );
};
